import React from 'react';
import PropTypes from 'prop-types';
import { themes, getTheme, ThemeContext } from '@ids/theme';
import A11yFocus from '@ids/a11yfocus';
import RcCheckbox from '@ids/rc-checkbox';
import { Label, WrapperLabel } from './StyledRadio';

const { bool, func, node, string, oneOf } = PropTypes;

/** A group */
export default class RadioBase extends React.PureComponent {
  static contextType = ThemeContext;

  static propTypes = {
    /**
     * Specifies whether the radio is selected.
     */
    // eslint-disable-next-line react/boolean-prop-naming
    checked: bool,
    /**
     * The  Radio label
     */
    children: node,
    /**
     * Disable the radio.
     */
    // eslint-disable-next-line react/boolean-prop-naming
    disabled: bool,
    /**
     * Radio current name.
     */
    name: string,
    /**
     * Callback function that is fired when a Radio has been selected. If part of a RadioGroup,
     * use that onChange instead.
     */
    onChange: func,
    /**
     * The application's ThemeProvider determines the default theme the component will use. Use
     * theme prop to override (e.g. 'mint', 'proconnect', 'quickbooks', 'turbotax').
     */
    theme: oneOf(themes),
    /**
     * Checkbox current value.
     */
    value: string
  };

  static defaultProps = {
    checked: false,
    children: null,
    disabled: false,
    name: undefined,
    onChange() {},
    theme: undefined,
    value: undefined
  };

  render() {
    const { children, theme, disabled, ...restProps } = this.props;
    const { currentTheme } = getTheme({ theme }, this.context);

    return (
      <WrapperLabel disabled={disabled} theme={currentTheme}>
        <A11yFocus passA11yFocusProp>
          <RcCheckbox
            type="radio"
            theme={currentTheme}
            disabled={disabled}
            {...restProps}
          />
        </A11yFocus>
        {children && <Label disabled={disabled}>{children}</Label>}
      </WrapperLabel>
    );
  }
}
